import { Button } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledButton = styled(Button)<{ $inWatchlist: boolean }>`
  visibility: visible;
  border: none;
  min-width: 155px;
  text-align: left;
  justify-content: left;

  ${({ $inWatchlist }) =>
    $inWatchlist &&
    `
      color: var(--text-success);
      svg {
        fill: var(--text-success)
      }

      &:hover {
        color: var(--text-success);
        background: var(--surface-success);
        svg {
          fill: var(--text-success)
        }
      }
    `}
`;
